// advisorProfile.slice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { advisorService } from './advisor.service';
import { setAlertError } from '../alert/alert.slice';

const initialState = {
  codes: [],
  loadingCodes: false,
  error: null
};

// --- GET CODES ASYNC ---
export const getCodes = createAsyncThunk('advisor/getCodes', async (userId, thunkAPI) => {
  try {
    const response = await advisorService.getCodes(userId);
    return response;
  } catch (error) {
    const err = error.response?.data || { message: 'Failed to fetch codes' };
    thunkAPI.dispatch(setAlertError(err.message));
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const advisorProfileSlice = createSlice({
  name: 'advisor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --- GET CODES ---
      .addCase(getCodes.pending, (state) => {
        state.loadingCodes = true;
        state.error = null;
      })
      .addCase(getCodes.fulfilled, (state, action) => {
        state.loadingCodes = false;
        state.codes = action.payload;
      })
      .addCase(getCodes.rejected, (state, action) => {
        state.loadingCodes = false;
        state.error = action.payload;
      });
  }
});

export default advisorProfileSlice.reducer;
